// React
import React from 'react';
import classNames from 'classnames';
// Material UI
import { CircularProgress } from '@material-ui/core';
// Styles
import useStyles from './CustomCircularProgress.styles';

const CustomCircularProgress = ({ classes, ...props }) => {
  const componentClasses = useStyles();
  return (
    <CircularProgress
      classes={{ root: classNames(componentClasses.root, classes.root) }}
      {...props}
    />
  );
};

CustomCircularProgress.defaultProps = {
  classes: {},
  color: 'primary',
  size: 24,
};

export default CustomCircularProgress;
